import { Component, EventEmitter, Input, OnInit, Output, NgModule, OnDestroy, ChangeDetectorRef, AfterViewInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { Location } from '@angular/common';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router, ActivatedRoute } from '@angular/router';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { DataHelper } from '@helpers/data.helper';
import { DomSanitizer } from '@angular/platform-browser';
import { environment, getBetGeniusLiveTracker, trackerUrl } from '@environments/environment';
import { HeadToHeadDialog } from './headtohead-dialog';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { sportRadarWidgetLanguageList } from '@app/constants/sportRadar.constant';
import { DeepValuePipe } from '@pipes/deepValue.pipe';
import { liveStreamData, LiveStreamService } from '@services/liveStream.service';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { OddModel } from '@app/models/odd.model';
declare let SIR: any;

declare global {
  interface Window {
    STATSCOREWidgets: any;
  }
}

@Component({
  selector: 'liveeventdetail-component',
  templateUrl: '../sharedTemplates/liveeventdetail.component.html',
})
export class LiveEventDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('search') search;
  filled = false;
  ismobile = this._UiHelper.windowsWidth < 990 ? true : false;
  searchValue = ''; // Arama değerini saklamak için
  isOpenSearchBar = false;
  public videoUrl: any = '';
  public iframeLoading = true;
  public iframeVisibility = 'hidden';
  public selectedTab = 'Tracker';
  deepValue = new DeepValuePipe();
  @Input() eventIdByInput = 0;
  @Input() showLiveList = true;
  isFavorite = false;

  eventDetailTabItemSelected = 2;

  SIROBJ;
  widgetEl;

  openLiveTrackerIsActive = false;

  eventdetailList = [];
  eventdetailListOriginal = [];
  selectedMarketValue = 2;

  event;
  _selectedOdds: OddModel[] = [];
  enableScoreBox = true;
  enableBetGeniusTracker = false;
  enableiframeTracker = false;

  betgeniustrackerlink: any;
  iframetrackerlink: any;

  eventid = 0;
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  isDesktop = window.innerWidth > 990;

  constructor(
    private _location: Location,
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _router: Router,
    private route: ActivatedRoute,
    public _LZ: LocalizationService,
    public _signalService: SignalrServiceLegacy,
    public _dataHelper: DataHelper,
    private _changeDetection: ChangeDetectorRef,
    private domSanitizer: DomSanitizer,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    public _LiveStreamService: LiveStreamService
  ) {
    if (this._DataHelper.selectedMatch !== undefined) {
      const favIndexOf = this._UserHelper.favoriedMatches.indexOf(this._DataHelper.selectedMatch.BetradarMatchId);

      if (favIndexOf > -1) this.isFavorite = true;
      else this.isFavorite = false;
    } else {
      this.isFavorite = false;
    }
  }
  public isTracerMapped = true;
  public lsTrackerWidget;
  subscriberoute;
  subscribesignalr;
  subscribeselectedodds;
  subscribelive;
  subscribeeventdetail;

  _isActiveSignalrConnectionListener: Subscription;
  ngOnInit() {
    if (this.eventIdByInput == 0) {
      this.subscriberoute = this.route.params.subscribe(params => {
        this.resetSubscriptions();
        this.eventid = params['eventid'];
        this.flagSIR = false;
        this.initialEventDetail();
        if (this.videoUrl === '') {
          this._LiveStreamService.liveEventDetailsSetTvUrl(params['eventid'], this.videoUrl, (newVideoUrl: any) => {
            this.videoUrl = newVideoUrl;
          });
        }
      });
    } else {
      this.eventid = this.eventIdByInput;
      this.initialEventDetail();
    }
    this._ApiService.getSelectedOdds();
    this._isActiveSignalrConnectionListener = this._UiHelper.isActiveSignalrConnectionListener.subscribe(state => {
      this.signalLiveConnection(state);
    });
    this.subscriptionsToStopOnDestroy.push(
      this._LiveStreamService.liveTvListListener.subscribe((x: liveStreamData[]) => {
        if (this.videoUrl === '' || this.videoUrl === undefined || this.videoUrl === 'waiting') {
          this._LiveStreamService.liveEventDetailsSetTvUrl(this.eventid, this.videoUrl, (newVideoUrl: any) => {
            this.videoUrl = newVideoUrl;
          });
        }
      })
    );
  }

  ngAfterViewInit() {
    fromEvent(this.search.nativeElement, 'input')
      .pipe(
        debounceTime(500), // 500ms bekleme süresi
        map((event: any) => event.target.value)
      )
      .subscribe(searchTerm => {
        this.searchOdd(searchTerm);
      });
    this.renderTracker();
    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      setTimeout(() => {
        this.renderLSTracker();
      }, 2000);

      this.renderer.listen(this.widgetEl, 'DOMSubtreeModified', event => {
        if (this.widgetEl.innerHTML === 'Widget could not be loaded.') {
          this.isTracerMapped = false;
        }
      });
    }
    if (this.videoUrl === '' || this.videoUrl === 'waiting') {
      this._LiveStreamService.liveEventDetailsSetTvUrl(this.eventid, this.videoUrl, (newVideoUrl: any) => {
        this.videoUrl = newVideoUrl;
      });
    }
  }
  sanitizedUrl;
  bypassSecurityTrustUrl() {
    this.sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
  }
  activeLoader() {
    this.iframeLoading = true;
    this.iframeVisibility = 'hidden';
  }

  hideLoader() {
    this.iframeLoading = false;
    this.iframeVisibility = 'visible';
  }
  isOpenTracker = false;
  setSelectTab(tab: string) {
    if (this.selectedTab !== tab && !(this.videoUrl === '' || this.videoUrl === 'waiting' || this.videoUrl === 'none')) {
      this.selectedTab = tab;
      if (tab === 'TV') {
        if (this.isDesktop) {
          this._LiveStreamService.setLiveStreamUrl(this.event);
          this._DataHelper.setSelectedTVTab = false;
        }
        this._LiveStreamService.liveStreamLiveEvent = true;
        this.bypassSecurityTrustUrl();
      } else {
        this._LiveStreamService.liveStreamLiveEvent = false;
        this.activeLoader();
      }
      if (this._LiveStreamService.liveStreamData && this._LiveStreamService.liveStreamData?.id) {
        this._LiveStreamService.resetLiveStreamUrl();
      }
    }

    if (tab === 'Tracker') {
      this.isOpenTracker = true;
    }
  }

  signalLiveConnection(state: boolean): void {
    if (state) {
      this.resetSubscriptions();
      this.initialEventDetail();
    } else {
      this.resetSubscriptions();
    }
  }

  initialEventDetail() {
    this.resetSubscriptions();

    //If connection is not exists
    if (!this._signalService.connectionExists) {
      this.subscribesignalr = this._signalService.connectionEstablished.subscribe(x => {
        this.subscribeHub();
      });
    } else {
      this.subscribeHub();
    }

    //Selected Odds Subscription
    this.subscribeselectedodds = this._ApiService.selectedOddsEvent.subscribe(x => {
      this._selectedOdds = x as OddModel[];
    });

    this._UiHelper.setNavbarTitle('LIVE');
  }

  iframesrc;
  flagSIR = false;
  subscribeHub() {
    //Signalr Subscription
    if (this.eventid != 0) {
      this._signalService.subscribeLiveEvent(this.eventid);
    }

    //Event Detail Odds Subscription
    this.subscribeeventdetail = this._dataHelper.liveEventDetailListener.subscribe(x => {
      this.eventdetailListOriginal = x;
      this.eventdetailList = x;
      if (this.selectedMarketValue != 2) {
        this.eventdetailList = this.eventdetailList.filter(s => s.IsChanged == this.selectedMarketValue);
      }
      if (this.isOpenSearchBar && this.searchValue !== '') {
        this.searchOdd(this.searchValue);
      }
      this._changeDetection.detectChanges();
    });

    this.renderTracker();

    this.subscribelive = this._dataHelper.liveDataListener.subscribe(y => {
      this.event = y.find(x => x.EventId == this.eventid);
      this._changeDetection.detectChanges();

      this.renderTracker();
    });
    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      this.renderLSTracker(this.eventid);
    }
  }

  element;
  renderLSTracker(eventId?) {
    if (eventId == undefined) {
      eventId = this.eventid;
    }
    const groupId = environment.tracker_GroupId;
    const inputData = { eventId: `m:${eventId}`, language: 'en', providerId: environment.tracker_ProviderId };
    if (eventId.toString().includes('-')) {
      inputData.eventId = `m:${eventId.toString().split('-')[1]}`;
      inputData.providerId = 109;
    }
    const options = {};
    const widget = new window.STATSCOREWidgets.WidgetGroup(this.element, groupId, inputData, options);
    this.lsTrackerWidget = widget;
  }

  languageWidget(): void {
    SIR('changeLanguage', this.deepValue.transform(sportRadarWidgetLanguageList, [[this._LZ.LANGCODE], 'isoCode']) || 'en');
  }

  renderTracker() {
    //Event Detail Event Subscription
    if (this._dataHelper.liveData != undefined && !this.flagSIR) {
      this.flagSIR = true;
      this.event = this._dataHelper.liveData.find(x => x.EventId == this.eventid);
      try {
        if (SIR != undefined) {
          if (this.event != undefined && this.event.BetradarMatchId > 0) {
            this.SIROBJ = SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', { layout: 'double', collapseTo: 'disable', pitchLogo: '', matchId: this.event.BetradarMatchId });
            this.languageWidget();
            if (this.SIROBJ) {
              this.enableScoreBox = false;
              this.enableBetGeniusTracker = false;
              this.isiframeloaded = false;
            } else {
              this.flagSIR = false;
            }
          } else if (this.event != undefined && this.event.MapMatchId && this.event.MapMatchId != '0' && this.event.MapMatchId !== '') {
            this.SIROBJ = SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', { layout: 'double', collapseTo: 'disable', pitchLogo: '', matchId: this.event.MapMatchId });
            this.languageWidget();
            if (this.SIROBJ) {
              this.enableScoreBox = false;
              this.enableBetGeniusTracker = false;
              this.isiframeloaded = false;
            } else {
              this.flagSIR = false;
            }
          } else {
            if (this.event != undefined) {
              //Thema ayarı burada yapıldı.
              if (this._UiHelper.getTheme() === 'theme-light') {
                this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl(getBetGeniusLiveTracker(this.event.BetradarMatchId, this._LZ.LANGCODE, '-light'));
              } else {
                this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl(getBetGeniusLiveTracker(this.event.BetradarMatchId, this._LZ.LANGCODE));
              }

              this.enableBetGeniusTracker = true;
              this.enableScoreBox = false;
              this.SIROBJ = SIR('removeWidget', '.sr-widget-1');
              this.languageWidget();
            } else {
              this.flagSIR = false;
            }
          }
        }
      } catch (e) {
        this.flagSIR = false;
        if (this.event != undefined && !this.iframesrc) {
          this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(`${trackerUrl}/tracker.html?e=` + this.event.BetradarMatchId);
        }
        this.isiframeloaded = true;
      }
    }
  }

  isiframeloaded = false;

  ngOnDestroy() {
    SIR('removeWidget', '.sr-widget-1');
    this.eventid = null;
    this.flagSIR = false;
    if (this.subscriberoute != undefined) {
      try {
        this.subscriberoute.unsubscribe();
      } catch (e) {
        console.log(e);
      }
    }

    if (this._isActiveSignalrConnectionListener) {
      this._isActiveSignalrConnectionListener.unsubscribe();
    }

    if (this.subscribeselectedodds != undefined) {
      try {
        this.subscribeselectedodds.unsubscribe();
      } catch (e) {
        console.log(e);
      }
    }
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this.resetSubscriptions();

    if (this.lsTrackerWidget && this.lsTrackerWidget.destroy) {
      try {
        this.lsTrackerWidget.destroy();
      } catch (e) {
        console.log(e);
      }
    }
    if (this._LiveStreamService.liveStreamLiveEvent) {
      this._LiveStreamService.liveStreamLiveEvent = false;
    }
  }

  resetSubscriptions() {
    this.SIROBJ = null;
    this._signalService.unSubscribeLiveEvent(this.eventid);
    try {
      if (this.subscribesignalr != undefined) {
        this.subscribesignalr.unsubscribe();
      }

      if (this.subscribelive != undefined) {
        this.subscribelive.unsubscribe();
      }

      if (this.subscribeeventdetail != undefined) {
        this.subscribeeventdetail.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }
  }

  getEventDetails(groupId = 2) {
    // this._ApiService.getEvent(this.eventid).then((x) => {
    //        if (x.length > 0)
    //            this.event = x[0];
    //    });
    //
    //    this._ApiService.getEventDetails(this.eventid, groupId).then((x) => {
    //        this.eventdetailList = x;
    //    });
  }

  marketTypeChanged(e) {
    this.selectedMarketValue = e;

    if (this.selectedMarketValue != 2) {
      this.eventdetailList = this.eventdetailListOriginal.filter(s => s.IsChanged == this.selectedMarketValue);
    } else {
      this.eventdetailList = this.eventdetailListOriginal;
    }
    this.isOpenSearchBar = false;

    //this._changeDetection.detectChanges();

    // this.getEventDetails(e);
  }

  clickOdd(e) {
    const newodd = {
      OddId: e.OddId,
    };

    //const index = this._ApiService.slipCurrents.findIndex((v) => {
    //  return v.OddId == e.OddId;
    //});
    //if (index > -1) {
    //  this._selectedOdds = this._selectedOdds.splice(index, 1);
    //} else {
    //  this._selectedOdds.push(newodd);
    //}

    this._ApiService.addLiveOdd(e.OddId);
  }

  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else return e;
  }

  removeBetValue(e) {
    return e.GroupName.replace(e.sbv, '');
  }

  eventDetailTabItemChange(tabId: number) {
    this.eventDetailTabItemSelected = tabId;

    if (tabId != undefined) {
      this.getEventDetails(tabId);
    }

    //Tab değişikliklerinde searchbarın kapatılmasını sağlıyorum.
    this.search.nativeElement.value = '';
    this.filled = false;
  }
  goBack() {
    let iseventİd = 0;
    this.route.params.subscribe(params => {
      iseventİd = params['eventid'];
    });
    if (iseventİd != undefined && iseventİd != 0) {
      this._location.back();
    } else {
      this._UiHelper.p1001SetMatchDetailDialog('close');
      // this.ngOnDestroy();
    }
  }

  addMatch2Favs(): void {
    if (this._UserHelper.isSignedIn) {
      this._DataHelper.setFavList(this.eventid * 1);
    }
  }
  ScrollToTop() {
    const elementList = document.querySelectorAll('#detailDialog');
    const element = elementList[0] as HTMLElement;
    if (element != null) {
      element.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (element.scrollTop === 0) {
      this.goBack();
    }
  }

  openHeadToHeadDialog(): void {
    const bID = this.event.BetradarMatchId < 0 ? this.event.BetradarMatchId * -1 : this.event.BetradarMatchId;
    const dialogRef = this.dialog.open(HeadToHeadDialog, {
      maxWidth: '100%',
      width: '100%',
      height: '95%',
      maxHeight: '95%',
      panelClass: 'h2hDialogClass',
      // disableClose: true,
      data: { matchId: this.event.BetradarMatchId },
    });
    dialogRef.afterClosed().subscribe();
  }
  addOdd2Favs(oddTypeId: number): void {
    let favorites = JSON.parse(localStorage.getItem('favoritedOdd') || '[]');
    const index = favorites.indexOf(oddTypeId);

    if (index > -1) {
      favorites.splice(index, 1); // Remove from favorites
    } else {
      favorites.push(oddTypeId); // Add to favorites
    }

    localStorage.setItem('favoritedOdd', JSON.stringify(favorites));
    this.updateList();
  }
  isOddFavorite(oddId: number): boolean {
    let favorites = JSON.parse(localStorage.getItem('favoritedOdd') || '[]');
    return favorites.includes(oddId);
  }
  updateList(): void {
    // Listenin bir kopyasını oluşturun ve yeniden atayın
    this.eventdetailList = [...this.eventdetailList];
  }
  searchOdd(searchTerm) {
    let filteredList;
    if (searchTerm.length >= 3) {
      filteredList = this.eventdetailListOriginal.filter(item => {
        const groupNamePart = item.OddType || '';
        return groupNamePart.toLowerCase().includes(searchTerm.toLowerCase());
      });
      this.eventdetailList = [];
      this.eventdetailList = filteredList;
    } else {
      this.eventdetailList = this.eventdetailListOriginal;
    }
  }

  openSearchBar() {
    this.isOpenSearchBar = !this.isOpenSearchBar;
    this.filled = !this.filled;

    this.searchValue = ''; // Her açılışta arama değerini sıfırla
    this.searchOdd(this.searchValue);
  }
  protected readonly Boolean = Boolean;
}
